import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, {useEffect, useMemo, useReducer} from "react";
import {Checkbox, ListItemText, MenuItem, Select, TextField} from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

import {useFetchAllLoadTypes} from "../../../../../hooks/guide/useFetchAllLoadTypes";
import {useFetchAllVehicleStatus} from "../../../../../hooks/guide/useFetchAllVehicleStatus";
import {useFetchAllTypeWastes} from "../../../../../hooks/guide/useFetchAllTypeWastes";
import {useFetchGetVehicleById} from "../../../../../hooks/guide/useFetchGetVehicleById";
import { useFetchAllGarage } from "../../../../../hooks/guide/useFetchAllGarage";

import {vehicleService} from "../../../../../services/guide/vehicle-service";
import {CreateVehicle, UpdateVehicle} from "../../../../../types/api/guide/vehicle.types";
import {useFetchAllTypeContainer} from "../../../../../hooks/guide/useFetchAllTypeContainer";
import {useFetchAllCounterparty} from "../../../../../hooks/guide/useFetchAllCounterparty";
import {useFetchAllTbo} from "../../../../../hooks/guide/useFetchAllTbo";

type FormState = {
    number: string;
    loadCapacity: number | "";
    volume: number | "";
    capacity: number | "";
    timeWork: number | "";
    loadTypeId: string;
    statusId: string;
    wastes: string[];
    typesContainer: string[];
    counterpartyId: string;
    garageId: string;
    tboId: string;
};

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = {
    number: "",
    loadCapacity: "",
    volume: "",
    capacity: "",
    timeWork: "",
    loadTypeId: "",
    statusId: "",
    wastes: [],
    typesContainer: [],
    counterpartyId: "",
    garageId: "",
    tboId: "",
};

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return {...state, [action.name]: action.value};
        case "SET_All":
            return {...action.payload};
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

interface VehicleAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id?: string;
}

export const VehicleAddModal = ({ onClose, refetchData, id }: VehicleAddModalProps) => {
    const {showSuccess, showError, SnackbarComponent} = useAppSnackbar();

    const isEdit = Boolean(id);

    const {data: loadTypes = []} = useFetchAllLoadTypes();
    const {data: statuses = []} = useFetchAllVehicleStatus();
    const {data: typeWastes = []} = useFetchAllTypeWastes();
    const {data: vehicle} = useFetchGetVehicleById(id);
    const {data: typeContainers} = useFetchAllTypeContainer();
    const {data: counterpaties } = useFetchAllCounterparty();
    const { data: garages = [] } = useFetchAllGarage();
    const {data: tbos = []} = useFetchAllTbo();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!vehicle) return;

        dispatch({
            type: "SET_All",
            payload: {
                number: vehicle.number ?? "",
                loadCapacity: vehicle.loadCapacity ?? "",
                volume: vehicle.volume ?? "",
                capacity: vehicle.capacity ?? "",
                timeWork: vehicle.timeWork ?? "",
                loadTypeId: vehicle.loadTypeId ?? "",
                statusId: vehicle.statusId ?? "",
                wastes: vehicle.acceptableWasteTypesIds ?? [],
                typesContainer: vehicle.typesContainer ?? [],
                counterpartyId: vehicle.counterpartyId ?? "",
                garageId: vehicle.garageId,
                tboId: vehicle.tboId,
            },
        });
    }, [vehicle]);

    const handleValue = (event: any) => {
        const {name, value} = event.target;

        if (name === "loadCapacity" || name === "volume" || name === "capacity" || name === "timeWork") {
            const next = value === "" ? "" : Number(value);
            dispatch({type: "SET_FIELD", name, value: next});
            return;
        }

        dispatch({type: "SET_FIELD", name, value});
    };

    const canSave = useMemo(() => {
        console.log(state)
        if (!state.number.trim()) return false;

        if (state.loadCapacity === "" || Number(state.loadCapacity) <= 0) return false;
        if (state.volume === "" || Number(state.volume) <= 0) return false;
        if (state.capacity === "" || Number(state.capacity) <= 0) return false;
        if (state.timeWork === "" || Number(state.timeWork) <= 0) return false;

        if (!state.loadTypeId) return false;
        if (!state.statusId) return false;

        if (state.wastes.length === 0) return false;

        return true;
    }, [state]);

    const handleSave = async () => {
        try {
            if (!vehicle) {
                const payload: CreateVehicle = {
                    number: state.number.trim(),
                    loadCapacity: Number(state.loadCapacity),
                    volume: Number(state.volume),
                    capacity: Number(state.capacity),
                    timeWork: Number(state.timeWork),
                    loadTypeId: state.loadTypeId,
                    statusId: state.statusId,
                    typeWastes: state.wastes,
                    typesContainer: state.typesContainer,
                    counterpartyId: state.counterpartyId,
                    garageId: state.garageId,
                    tboId: state.tboId,
                };

                await vehicleService.create(payload);
                showSuccess("ТС создано");
            } else {
                const payload: UpdateVehicle = {
                    id: vehicle.id,
                    number: state.number.trim(),
                    loadCapacity: Number(state.loadCapacity),
                    volume: Number(state.volume),
                    capacity: Number(state.capacity),
                    timeWork: Number(state.timeWork),
                    loadTypeId: state.loadTypeId,
                    statusId: state.statusId,
                    typeWastes: state.wastes,
                    typesContainer: state.typesContainer,
                    counterpartyId: state.counterpartyId,
                    garageId: state.garageId,
                    tboId: state.tboId,
                };
                console.log(payload);
                await vehicleService.update(vehicle.id, payload);
                showSuccess("ТС обновлено");
            }
            refetchData();
            onClose();
        } catch (e: any) {
            showError("Ошибка при обновлении/создании");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>{isEdit ? "Редактировать транспорт" : "Добавить транспорт"}</h3>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Номер</div>
                        <div className={styles.modalCoords}>
                            <TextField name="number" value={state.number} onChange={handleValue} fullWidth/>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Грузоподъёмность</div>
                        <div className={styles.modalCoords}>
                            <TextField name="loadCapacity" type="number" value={state.loadCapacity}
                                       onChange={handleValue} fullWidth/>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Объём</div>
                        <div className={styles.modalCoords}>
                            <TextField name="volume" type="number" value={state.volume} onChange={handleValue}
                                       fullWidth/>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Вместимость</div>
                        <div className={styles.modalCoords}>
                            <TextField name="capacity" type="number" value={state.capacity} onChange={handleValue}
                                       fullWidth/>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Время работы</div>
                        <div className={styles.modalCoords}>
                            <TextField name="timeWork" type="number" value={state.timeWork} onChange={handleValue}
                                       fullWidth/>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Контрагент</div>
                        <div className={styles.modalCoords}>
                            <Select name="counterpartyId"
                                    value={state.counterpartyId}
                                    onChange={handleValue}
                                    fullWidth
                                    displayEmpty renderValue={(selected) =>
                                counterpaties.find((t: any) => t.id === selected)?.name ??
                                (selected ? String(selected) : "Выберите контрагента")
                            }
                                    MenuProps={{disablePortal: true, PaperProps: {sx: {zIndex: 20000}}}}
                            >
                                {counterpaties.map((t: any) => (
                                    <MenuItem key={t.id} value={t.id}>
                                        <ListItemText primary={t.name}/>
                                    </MenuItem>))}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Гараж</div>
                        <div className={styles.modalCoords}>
                            <Select
                                name="garageId"
                                value={state.garageId}
                                onChange={handleValue}
                                fullWidth
                                displayEmpty
                                renderValue={(selected) =>
                                    garages.find((g: any) => g.id === selected)?.name ??
                                    (selected ? String(selected) : "Выберите гараж")
                                }
                                MenuProps={{ disablePortal: true, PaperProps: { sx: { zIndex: 20000 } } }}
                            >
                                <MenuItem value="">
                                    <ListItemText primary="Не выбрано" />
                                </MenuItem>

                                {garages.map((g: any) => (
                                    <MenuItem key={g.id} value={g.id}>
                                        <ListItemText primary={g.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>ТБО</div>
                        <div className={styles.modalCoords}>
                            <Select
                                name="tboId"
                                value={state.tboId}
                                onChange={handleValue}
                                fullWidth
                                displayEmpty
                                renderValue={(selected) =>
                                    tbos.find((t) => t.id === selected)?.name ??
                                    (selected ? String(selected) : "Выберите ТБО")
                                }
                                MenuProps={{ disablePortal: true, PaperProps: { sx: { zIndex: 20000 } } }}
                            >
                                <MenuItem value="">
                                    <ListItemText primary="Не выбрано" />
                                </MenuItem>

                                {tbos.map((t) => (
                                    <MenuItem key={t.id} value={t.id}>
                                        <ListItemText primary={t.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Тип загрузки</div>
                        <div className={styles.modalCoords}>
                            <Select name="loadTypeId"
                                    value={state.loadTypeId}
                                    onChange={handleValue}
                                    fullWidth
                                    displayEmpty renderValue={(selected) =>
                                loadTypes.find((t: any) => t.id === selected)?.name ??
                                (selected ? String(selected) : "Выберите тип")
                            }
                                    MenuProps={{disablePortal: true, PaperProps: {sx: {zIndex: 20000}}}}
                            >
                                {loadTypes.map((t: any) => (
                                    <MenuItem key={t.id} value={t.id}>
                                        <ListItemText primary={t.name}/>
                                    </MenuItem>))}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Статус</div>
                        <div className={styles.modalCoords}>
                            <Select name="statusId"
                                    value={state.statusId}
                                    onChange={handleValue}
                                    fullWidth
                                    displayEmpty renderValue={(selected) =>
                                statuses.find((t: any) => t.id === selected)?.name ??
                                (selected ? String(selected) : "Выберите статус")
                            }
                                    MenuProps={{disablePortal: true, PaperProps: {sx: {zIndex: 20000}}}}
                            >
                                {statuses.map((s: any) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        <ListItemText primary={s.name}/>
                                    </MenuItem>))}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Типы отходов</div>
                        <div className={styles.modalCoords}>
                            <Select name="wastes"
                                    value={state.wastes}
                                    onChange={handleValue}
                                    fullWidth
                                    multiple displayEmpty renderValue={(selected) => {
                                const arr = selected as string[];
                                if (arr.length === 0) return <span style={{opacity: 0.6}}>Выберите типы отходов</span>;

                                return typeWastes
                                    .filter((s: any) => arr.includes(s.id))
                                    .map((s: any) => s.name)
                                    .join(", ");
                            }}
                                    MenuProps={{disablePortal: true, PaperProps: {sx: {maxHeight: 360, zIndex: 20000}}}}
                            >
                                {typeWastes.map((s: any) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        <Checkbox checked={state.wastes.includes(s.id)}/>
                                        <ListItemText primary={s.name}/>
                                    </MenuItem>))}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Типы контейнеров</div>
                        <div className={styles.modalCoords}>
                            <Select name="typesContainer"
                                    value={state.typesContainer}
                                    onChange={handleValue}
                                    fullWidth
                                    multiple displayEmpty renderValue={(selected) => {
                                const arr = selected as string[];
                                if (arr.length === 0) return <span style={{opacity: 0.6}}>Выберите типы контейнеров</span>;

                                return typeContainers
                                    .filter((s: any) => arr.includes(s.id))
                                    .map((s: any) => s.name)
                                    .join(", ");
                            }}
                                    MenuProps={{disablePortal: true, PaperProps: {sx: {maxHeight: 360, zIndex: 20000}}}}
                            >
                                {typeContainers.map((s: any) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        <Checkbox checked={state.typesContainer.includes(s.id)}/>
                                        <ListItemText primary={s.name}/>
                                    </MenuItem>))}
                            </Select>
                        </div>
                    </div>
                </div>
                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>Отмена</button>
                    <button className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                            onClick={handleSave}
                            disabled={!canSave}
                            style={{opacity: canSave ? 1 : 0.6}}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
            <SnackbarComponent/></div>);
};